import React from "react";

/**
 * Constant motion — the one context where linear timing is correct.
 * Duplicated content plus a -50% keyframe gives a seamless loop with no JS.
 */
const Marquee = ({ items, duration = 42, className = "", separator = "/" }) => {
  const run = [...items, ...items];

  return (
    <div className={`marquee-host relative overflow-hidden ${className}`} aria-hidden="true">
      <div className="marquee-track" style={{ "--marquee-duration": `${duration}s` }}>
        {run.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center whitespace-nowrap">
            <span>{item}</span>
            <span className="mx-[1.5vw] text-flare">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
